import Cgl from 'Cgl';
import Vue from 'vue';
import VueRouter from 'vue-router';
import { registerMicroApps, start } from 'qiankun';

import CmnMis from 'CmnMis';

import UserForm from '../views/Default/Components/UserForm';
import Login from '../views/Login';
import Default from '../views/Default';
import Tools from "../views/Tools"

const store = CmnMis.Store;

Vue.use(VueRouter);

//解决路由重复报错问题
const RouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return RouterPush.call(this, location).catch(error => {});
};

let router = null;

export { router };

export const initRouter = (rtr, base) => {
    router = rtr;

    if (__MAIN_SYSTEM__) {
        router.beforeEach(async (to, from, next) => {
            let userID = store.state.LoginInfo.UserID || "";
            if (!userID) {
                try {
                    userID = await CmnMis.Func.GetLoginUserID();
                } catch (e) {
                    if (to.name === 'login') {
                        next();
                    } else {
                        next('/login?ReturnUrl=' + encodeURIComponent(location.href));
                    }
                    return;
                }
            }

            if (userID) {
                next();
            } else {
                next('/login?ReturnUrl=' + encodeURIComponent(location.href));
            }
        });
    }

    let microAppIsInitCompleted = false;

    router.afterEach((to, from) => {
        if (!microAppIsInitCompleted) {
            microAppIsInitCompleted = true;

            if (
                to.matched.length === 2 &&
                to.matched[0].components.default === Default
            ) {
                CmnMis.Frame.OnShowUserForm.AddTriggerOne(userform => {
                    userform.OnLoad.AddTriggerOne(() => {
                        Vue.nextTick(() => {
                            start({
                                prefetch: false,
                                singular: true
                            });
                        });
                    });
                });
            } else {
                Vue.nextTick(() => {
                    start({
                        prefetch: false,
                        singular: true
                    });
                });
            }
        }
    });

    router.addRoutes([
        ...(__MAIN_SYSTEM__
            ? [
                  {
                      path: '/login',
                      name: 'login',
                      component: Login
                  },
                  {
                      path: '/Tools*',
                      name: "Tools",
                      component: Tools
                  },
                  {
                    path: '/view-template*',
                    name: "ViewTemplate",
                    component: Tools
                }
              ]
            : []),
        {
            path: base ?? '/',
            component: Default,
            children: [
                {
                    path: ':ufmid/',
                    component: {
                        render(h) {
                            return h('div');
                        }
                    }
                },
                {
                    path: ':ufmid/:ufid',
                    component: UserForm
                }
            ]
        },
        {
            path: (base ? base : '/') + ':sysguid',
            component: Default,
            children: [
                {
                    path: ':ufmid/',
                    component: {
                        render(h) {
                            return h('div');
                        }
                    }
                },
                {
                    path: ':ufmid/:ufid',
                    component: UserForm
                }
            ]
        },
        {
            path: (base ? '/' + base : '') + '/500',
            component: () =>
                import(
                    /* webpackChunkName: "Page500" */ '../views/ErrorPages/500/index.vue'
                )
        },
        {
            path: (base ? '/' + base : '') + '*',
            component: () =>
                import(
                    /* webpackChunkName: "Page404" */ '../views/ErrorPages/404/index.vue'
                )
        }
    ]);

    setTimeout(() => {
        Promise.all([
            // __MAIN_SYSTEM__
            //     ? CmnMis.Func.GetSysCfg('LoginTemplate').catch(() => "")
            //     : Promise.resolve(),
            Array.isArray(store.state.SubsysList)
                ? Promise.resolve(store.state.SubsysList)
                : store.dispatch('GetSubsysList').catch(() => [])
        ]).then(([]) => {
            registerMicroApps([
                ...(__MAIN_SYSTEM__
                    ? [
                          {
                              name: 'Login',
                              entry: SiteConfig?.LoginTemplate || 'ui/login/index.html',
                              activeRule: location => {
                                  const hash = location.hash;
                                  const args = [1];
                                  if (hash.indexOf('?') > -1) {
                                      args.push(hash.indexOf('?'));
                                  }

                                  return (
                                      String.prototype.slice.apply(
                                          hash,
                                          args
                                      ) === '/login'
                                  );
                              },
                              container: '.login-app-wrapper',
                              props: {
                                  Vue,
                                  store,
                                  router
                              }
                          }
                      ]
                    : []),
                ...(!__MAIN_SYSTEM__ ? [] : (store.state.SubsysList || [])).map(
                    subsys => ({
                        name: subsys.sys_name,
                        entry: `${Cgl.Url.GetRoot()}/Itf/Java/Subsys/${subsys.sys_guid +
                            new URL(subsys.extranet_root_url)
                                .pathname}/Default.html`,
                        activeRule: location => {
                            if (!store.state.LoginInfo.UserID) {
                              return false;
                            }
                            const hash = location.hash;
                            const args = [1];
                            if (hash.indexOf('?') > -1) {
                                args.push(hash.indexOf('?'));
                            }

                            return String.prototype.slice
                                .apply(hash, args)
                                .startsWith('/' + subsys.sys_guid);
                        },
                        container: `.subsys-userform-view`,
                        props: {
                            sysList: JSON.parse(JSON.stringify(store.state.SubsysList)),
                            sysInfo: subsys,
                            base: '/' + subsys.sys_guid + '/',
                            Frame: CmnMis.Frame
                        }
                    })
                )
            ]);
        });
    });

    if (!__MAIN_SYSTEM__) {
        store.commit('SetSubsys', true);
    }
};

export const destroyRouter = () => {
    router = null;
};
